const Plus = () => {
	return (
		<svg xmlns='http://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 24 24' fill='none'>
			<path
				d='M3.94336 11.9492C3.94336 11.7083 4.02799 11.5033 4.19727 11.334C4.37305 11.1582 4.57812 11.0703 4.8125 11.0703H11.1309V4.76172C11.1309 4.52734 11.2155 4.32552 11.3848 4.15625C11.554 3.98047 11.7591 3.89258 12 3.89258C12.2409 3.89258 12.446 3.98047 12.6152 4.15625C12.791 4.32552 12.8789 4.52734 12.8789 4.76172V11.0703H19.1875C19.4219 11.0703 19.6237 11.1582 19.793 11.334C19.9688 11.5033 20.0566 11.7083 20.0566 11.9492C20.0566 12.1901 19.9688 12.3952 19.793 12.5645C19.6237 12.7337 19.4219 12.8184 19.1875 12.8184H12.8789V19.1367C12.8789 19.3711 12.791 19.5729 12.6152 19.7422C12.446 19.918 12.2409 20.0059 12 20.0059C11.7591 20.0059 11.554 19.918 11.3848 19.7422C11.2155 19.5729 11.1309 19.3711 11.1309 19.1367V12.8184H4.8125C4.57812 12.8184 4.37305 12.7337 4.19727 12.5645C4.02799 12.3952 3.94336 12.1901 3.94336 11.9492Z'
				fill='#21242D'
			/>
		</svg>
	);
};

export default Plus;
